import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, resolveDirective as _resolveDirective, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { class: "map-legend" }
const _hoisted_2 = {
  key: 0,
  class: "map-legend__title m-0 mb-8"
}
const _hoisted_3 = { class: "map-legend-item__text" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _directive_tooltip = _resolveDirective("tooltip")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.unit)
      ? (_openBlock(), _createElementBlock("h4", _hoisted_2, _toDisplayString(_ctx.$t(`unit.${_ctx.unit}`)), 1))
      : _createCommentVNode("", true),
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.displayList, (item) => {
      return _withDirectives((_openBlock(), _createElementBlock("div", {
        key: JSON.stringify(item),
        class: _normalizeClass(['width-100', 'map-legend-item', { 'map-legend-item--unused': _ctx.isUnused(item) }])
      }, [
        _createElementVNode("div", null, [
          _createElementVNode("span", {
            class: "map-legend-item__color mr-8",
            style: _normalizeStyle({ background: item.color })
          }, null, 4)
        ]),
        _createElementVNode("span", _hoisted_3, _toDisplayString(_ctx.formatMinMax(item.min, item.max)), 1)
      ], 2)), [
        [
          _directive_tooltip,
          _ctx.isUnused(item) ? _ctx.$t('message.unusedLegendItem') : '',
          void 0,
          { left: true }
        ]
      ])
    }), 128))
  ]))
}